import IndexPage from "../../components/organisms/Travel/index";

const FormPage = (props) =>{
    return <IndexPage sendGTM={props.sendGTM}/>
};
export default FormPage;